import { render } from "./HiVaultFileDrop.vue?vue&type=template&id=1d5a36e0"
import script from "./HiVaultFileDrop.vue?vue&type=script&lang=js"
export * from "./HiVaultFileDrop.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__